import { SVGAttributes } from "react";

const ChainSvg = (props: SVGAttributes<SVGElement>) => {
  return (
    <svg
      viewBox="0 0 29 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.31988 23.1269C2.04542 25.4014 2.04542 29.089 4.31988 31.3635C6.59435 33.6379 10.282 33.6379 12.5564 31.3635L19.2487 24.6713C21.5231 22.3968 21.5231 18.7092 19.2487 16.4347C18.0186 15.2047 16.3753 14.6398 14.7657 14.7402"
        stroke="#CFB2FF"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.8818 12.8311C26.1562 10.5566 26.1562 6.86901 23.8818 4.59455C21.6073 2.32009 17.9197 2.32009 15.6452 4.59455L8.953 11.2867C6.67853 13.5612 6.67853 17.2488 8.953 19.5233C10.183 20.7533 11.8263 21.3182 13.4359 21.2178"
        stroke="#FFA686"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ChainSvg;
